import { render, staticRenderFns } from "./NullResult.vue?vue&type=template&id=35d44f30&scoped=true&"
import script from "./NullResult.vue?vue&type=script&lang=js&"
export * from "./NullResult.vue?vue&type=script&lang=js&"
import style0 from "./NullResult.vue?vue&type=style&index=0&id=35d44f30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d44f30",
  null
  
)

export default component.exports